import { render, staticRenderFns } from "./trainTaskListBtn.vue?vue&type=template&id=595a45b8&scoped=true&"
import script from "./trainTaskListBtn.vue?vue&type=script&lang=js&"
export * from "./trainTaskListBtn.vue?vue&type=script&lang=js&"
import style0 from "./trainTaskListBtn.vue?vue&type=style&index=0&id=595a45b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a45b8",
  null
  
)

export default component.exports